var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'accent-' + _vm.accent,
        'theme-' + _vm.darkness
    ],attrs:{"id":"app"}},[_c('transition',{attrs:{"name":_vm.transition,"mode":"in-out"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }